(function () {
  if (window.AxiomVariantForm) return;

  function getStateMap(state) {
    if (!state) return {};
    return state.variants || state;
  }

  function getVariantState(variant, state) {
    if (!variant) return null;
    return getStateMap(state)[String(variant.id)] || null;
  }

  function getQuantityRule(variant, state) {
    var variantState = getVariantState(variant, state);
    var rule = variantState && variantState.quantityRule ? variantState.quantityRule : (variant && (variant.quantity_rule || variant.quantityRule)) || {};
    return {
      min: Math.max(1, parseInt(rule.min || 1, 10) || 1),
      max: rule.max === null || rule.max === undefined || rule.max === '' ? null : parseInt(rule.max, 10),
      increment: Math.max(1, parseInt(rule.increment || 1, 10) || 1)
    };
  }

  function shouldCheckInventory(variant, state) {
    var variantState = getVariantState(variant, state);
    var inventoryManagement = variantState && variantState.inventoryManagement !== undefined
      ? variantState.inventoryManagement
      : variant && variant.inventory_management;
    var inventoryPolicy = variantState && variantState.inventoryPolicy !== undefined
      ? variantState.inventoryPolicy
      : variant && variant.inventory_policy;
    return inventoryManagement === 'shopify' && inventoryPolicy !== 'continue';
  }

  function getInventoryQuantity(variant, state) {
    var variantState = getVariantState(variant, state);
    if (variantState && variantState.inventoryQuantity !== undefined && variantState.inventoryQuantity !== null) {
      return parseInt(variantState.inventoryQuantity, 10) || 0;
    }
    return parseInt((variant && variant.inventory_quantity) || 0, 10) || 0;
  }

  function variantRequiresSellingPlan(variant, state) {
    var variantState = getVariantState(variant, state);
    if (variantState && variantState.requiresSellingPlan !== undefined) {
      return Boolean(variantState.requiresSellingPlan);
    }
    return Boolean(variant && variant.requires_selling_plan);
  }

  function getSellingPlanAllocations(variant, state) {
    var variantState = getVariantState(variant, state);
    if (variantState && Array.isArray(variantState.sellingPlanAllocations)) {
      return variantState.sellingPlanAllocations;
    }
    if (variant && Array.isArray(variant.selling_plan_allocations)) {
      return variant.selling_plan_allocations;
    }
    return [];
  }

  function getSellingPlanAllocationById(variant, state, sellingPlanId) {
    if (!sellingPlanId) return null;
    return getSellingPlanAllocations(variant, state).find(function (allocation) {
      return String(allocation.sellingPlanId || allocation.selling_plan_id || (allocation.selling_plan && allocation.selling_plan.id) || '') === String(sellingPlanId);
    }) || null;
  }

  function getFirstSellingPlanAllocation(variant, state) {
    var allocations = getSellingPlanAllocations(variant, state);
    return allocations.length ? allocations[0] : null;
  }

  function isSoldOut(variant, state) {
    var variantState = getVariantState(variant, state);
    var available = variantState && variantState.available !== undefined ? variantState.available : variant && variant.available;
    if (!variant || !available) return true;
    return shouldCheckInventory(variant, state)
      && getInventoryQuantity(variant, state) < getQuantityRule(variant, state).min;
  }

  function findAvailableVariantForOptionValue(product, selected, position, value, state) {
    var optionPosition = parseInt(position, 10);
    if (!product || !Array.isArray(product.variants) || !optionPosition) return null;
    return product.variants.find(function (variant) {
      var options = getVariantOptions(variant);
      if (options[optionPosition - 1] !== value || isSoldOut(variant, state)) return false;
      for (var index = 0; index < optionPosition - 1; index += 1) {
        var selectedValue = selected && selected[index + 1];
        if (selectedValue !== undefined && selectedValue !== null && selectedValue !== '' && options[index] !== selectedValue) {
          return false;
        }
      }
      return true;
    }) || null;
  }

  function isOptionValueAvailable(product, selected, position, value, state) {
    return Boolean(findAvailableVariantForOptionValue(product, selected, position, value, state));
  }

  function getEffectiveMaxQty(variant, state) {
    var quantityRule = getQuantityRule(variant, state);
    var variantState = getVariantState(variant, state);
    var cartQuantity = Math.max(0, parseInt(variantState && variantState.cartQuantity, 10) || 0);
    var totalMax = quantityRule.max;
    if (shouldCheckInventory(variant, state)) {
      var inventoryMax = getInventoryQuantity(variant, state);
      totalMax = totalMax === null ? inventoryMax : Math.min(totalMax, inventoryMax);
    }
    return totalMax === null ? null : Math.max(0, totalMax - cartQuantity);
  }

  function getMinimumAddQty(variant, state) {
    var rule = getQuantityRule(variant, state);
    var variantState = getVariantState(variant, state);
    var cartQuantity = Math.max(0, parseInt(variantState && variantState.cartQuantity, 10) || 0);
    return cartQuantity >= rule.min ? rule.increment : rule.min;
  }

  function syncCartQuantity(variant, state, cart) {
    var variantState = getVariantState(variant, state);
    if (!variantState || !cart || !window.AxiomStandardStorefront) return;
    var lines = window.AxiomStandardStorefront.getCartLines(cart);
    variantState.cartQuantity = lines.reduce(function (total, line) {
      var id = line && line.merchandise && line.merchandise.id || line && line.merchandiseId || '';
      return String(id).split('/').pop() === String(variant.id)
        ? total + (parseInt(line.quantity, 10) || 0)
        : total;
    }, 0);
  }

  function normalizeQty(rawValue, variant, state, allowZero) {
    var quantityRule = getQuantityRule(variant, state);
    var min = getMinimumAddQty(variant, state);
    var increment = quantityRule.increment;
    var max = getEffectiveMaxQty(variant, state);
    if (max !== null && max < min) return 0;
    var value = parseInt(rawValue, 10);
    if (!Number.isFinite(value)) value = allowZero ? 0 : min;
    if (allowZero && value <= 0) return 0;
    if (value < min) value = min;
    if (value > min) {
      var remainder = (value - min) % increment;
      if (remainder !== 0) value -= remainder;
    }
    if (max !== null && value > max) {
      value = max;
      if (value >= min) value -= (value - min) % increment;
    }
    if (!allowZero && value < min) value = min;
    return Math.max(allowZero ? 0 : min, value);
  }

  function selectedOptions(root, buttonSelector) {
    var selected = {};
    if (!root || !buttonSelector) return selected;
    root.querySelectorAll(buttonSelector + '.active').forEach(function (button) {
      selected[parseInt(button.dataset.optionPosition, 10)] = button.dataset.value;
    });
    return selected;
  }

  // Combined listings: a value that belongs to another product of the listing carries
  // data-option-product-url (snippets/product-option-value-product-url.liquid). Such a value has no
  // variant in the current product, so its availability stays Shopify's (Liquid value.available) and
  // choosing it loads that product with the other selected values kept: option_values lists the
  // selected value ids in option order and see resolveOtherProductOptionUrl for the variant picked.
  function isOtherProductOption(button) {
    return Boolean(button && button.dataset.optionProductUrl);
  }

  function otherProductOptionUrl(root, buttonSelector, button) {
    if (!isOtherProductOption(button)) return '';
    var selected = {};
    if (root && buttonSelector) {
      root.querySelectorAll(buttonSelector + '.active').forEach(function (item) {
        selected[parseInt(item.dataset.optionPosition, 10)] = item.dataset.optionValueId;
      });
    }
    selected[parseInt(button.dataset.optionPosition, 10)] = button.dataset.optionValueId;
    var optionValueIds = Object.keys(selected).map(Number).sort(function (a, b) {
      return a - b;
    }).map(function (position) {
      return selected[position];
    }).filter(Boolean);
    var url = new URL(button.dataset.optionProductUrl, window.location.origin);
    if (optionValueIds.length) url.searchParams.set('option_values', optionValueIds.join(','));
    return url.toString();
  }

  // The other product often lacks some of the current values (e.g. Animal Print has no Black), and
  // option_values for a combination it doesn't have leaves no variant selected. So read that
  // product's variants and pick the closest one: it has the chosen value, keeps as many of the
  // other selected values as possible, and is available when one is. Falls back to option_values.
  function resolveOtherProductOptionUrl(root, buttonSelector, button, signal) {
    var fallback = otherProductOptionUrl(root, buttonSelector, button);
    if (!fallback) return Promise.resolve('');
    var position = parseInt(button.dataset.optionPosition, 10);
    var selected = {};
    if (root && buttonSelector) {
      root.querySelectorAll(buttonSelector + '.active').forEach(function (item) {
        selected[parseInt(item.dataset.optionPosition, 10)] = item.dataset.value;
      });
    }
    selected[position] = button.dataset.value;
    var productUrl = new URL(button.dataset.optionProductUrl, window.location.origin);
    return fetch(productUrl.pathname + '.js', { credentials: 'same-origin', signal: signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Product request failed.');
        return response.json();
      })
      .then(function (product) {
        var best = null;
        var bestScore = -1;
        (product.variants || []).forEach(function (variant) {
          var options = getVariantOptions(variant);
          if (options[position - 1] !== selected[position]) return;
          var score = variant.available ? 100 : 0;
          options.forEach(function (value, index) {
            if (index !== position - 1 && selected[index + 1] === value) score += 1;
          });
          if (score > bestScore) {
            best = variant;
            bestScore = score;
          }
        });
        if (!best) return fallback;
        productUrl.search = '';
        productUrl.searchParams.set('variant', best.id);
        return productUrl.toString();
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') throw error;
        return fallback;
      });
  }

  // Combined listings: the option whose values carry a product URL (e.g. Finish) picks the product
  // of the listing; its buttons carry data-combined-listing-option (snippets/product-option-picker.liquid).
  // Values of the other options that no variant has with its selected value belong to the listing's
  // other products: they are hidden, not crossed out, and Liquid renders them so. Returns 0 outside
  // a combined listing, where nothing changes.
  function combinedListingPosition(root, buttonSelector) {
    var button = root && buttonSelector && root.querySelector(buttonSelector + '[data-combined-listing-option]');
    return button ? parseInt(button.dataset.optionPosition, 10) || 0 : 0;
  }

  function syncCombinedListingValues(root, buttonSelector, product, selected) {
    var position = combinedListingPosition(root, buttonSelector);
    if (!position || !product || !Array.isArray(product.variants)) return;
    var listingValue = selected && selected[position];
    var listingVariants = product.variants.filter(function (variant) {
      return getVariantOptions(variant)[position - 1] === listingValue;
    });
    root.querySelectorAll(buttonSelector).forEach(function (button) {
      var buttonPosition = parseInt(button.dataset.optionPosition, 10);
      if (!buttonPosition || buttonPosition === position) return;
      // A listing value without variants here (another product's, on a child product) hides nothing.
      var hidden = listingVariants.length > 0 && !listingVariants.some(function (variant) {
        return getVariantOptions(variant)[buttonPosition - 1] === button.dataset.value;
      });
      if (button.hidden !== hidden) button.hidden = hidden;
    });
  }

  // A new value of the listing option keeps the other selections where a variant has them, the
  // earlier options first (the colour before the size), else the first available variant.
  function findCombinedListingVariant(product, selected, position, value, state) {
    var optionPosition = parseInt(position, 10);
    if (!product || !Array.isArray(product.variants) || !optionPosition) return null;
    var best = null;
    var bestScore = -1;
    product.variants.forEach(function (variant) {
      var options = getVariantOptions(variant);
      if (options[optionPosition - 1] !== value) return;
      // Each kept selection outweighs all later ones together; availability decides the rest.
      var score = isSoldOut(variant, state) ? 0 : 1;
      options.forEach(function (optionValue, index) {
        if (index !== optionPosition - 1 && selected && selected[index + 1] === optionValue) {
          score += Math.pow(2, options.length - index);
        }
      });
      if (score > bestScore) {
        best = variant;
        bestScore = score;
      }
    });
    return best;
  }

  function getVariantOptions(variant) {
    if (!variant) return [];
    if (Array.isArray(variant.options)) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter(function (value) {
      return value !== null && value !== undefined && value !== '';
    });
  }

  function findVariant(product, selected) {
    if (!product || !product.variants) return null;
    if (product.variants.length === 1 && Object.keys(selected || {}).length === 0) {
      return product.variants[0];
    }
    return product.variants.find(function (variant) {
      var options = getVariantOptions(variant);
      if (!options.length) return false;
      return options.every(function (value, index) {
        return selected[index + 1] === value;
      });
    }) || null;
  }

  function getVariantImageUrl(variant, width) {
    if (!variant) return '';
    var featuredImage = variant.featured_image || variant.featuredImage;
    var featuredMedia = variant.featured_media || variant.featuredMedia;
    var previewImage = featuredMedia && (featuredMedia.preview_image || featuredMedia.previewImage);
    var source = featuredImage && (featuredImage.src || featuredImage.url)
      || previewImage && (previewImage.src || previewImage.url)
      || (typeof featuredImage === 'string' ? featuredImage : '');
    if (!source) return '';
    try {
      var url = new URL(source, window.location.origin);
      url.searchParams.set('width', String(width || 120));
      return url.toString();
    } catch (error) {
      return source;
    }
  }

  function getContextualOptionMediaUrl(state, position, optionValueId) {
    var option = (state && state.options || []).find(function (entry) {
      return Number(entry.position) === Number(position);
    });
    if (!option) return '';
    var value = (option.values || []).find(function (entry) {
      return String(entry.id) === String(optionValueId);
    });
    return value && value.mediaUrl ? String(value.mediaUrl) : '';
  }

  function setVariantImageSwatchLoading(button, isLoading) {
    if (!button) return;
    button.classList.toggle('is-variant-image-loading', Boolean(isLoading));
    if (isLoading) button.setAttribute('aria-busy', 'true');
    else button.removeAttribute('aria-busy');
  }

  // An image swatch paints no swatch colour underneath, so scaled/anti-aliased
  // edges (cursor parallax) cannot reveal it. The inline translate/scale owned by
  // component-variant-cursor-parallax.js survives the style reset.
  function applyVariantImageSwatchStyle(button, mediaUrl) {
    var translate = button.style.translate;
    var scale = button.style.scale;
    button.style.cssText = mediaUrl ? '' : (button.dataset.swatchFallbackStyle || '');
    if (mediaUrl) {
      button.style.setProperty('--variant-option-image', 'url(' + JSON.stringify(mediaUrl) + ')');
      button.style.setProperty('--swatch-bg', 'transparent');
    }
    if (translate) button.style.translate = translate;
    if (scale) button.style.scale = scale;
    button.dataset.variantImageUrl = mediaUrl;
  }

  function setVariantImageSwatchesLoading(options, isLoading) {
    var root = options && options.root;
    var selector = options && options.buttonSelector;
    if (!root || !selector) return;
    root.querySelectorAll(selector + '[data-variant-image-swatch]').forEach(function (button) {
      setVariantImageSwatchLoading(button, isLoading);
    });
  }

  function syncVariantImageSwatches(options) {
    var root = options && options.root;
    var selector = options && options.buttonSelector;
    if (!root || !selector) return;
    var product = options.product;
    var selected = options.selected || {};
    var contextualState = options.contextualState;

    root.querySelectorAll(selector + '[data-variant-image-swatch]').forEach(function (button) {
      // Another product's value has no variant here: keep the image Liquid rendered for it.
      if (!contextualState && isOtherProductOption(button)) return;
      var position = parseInt(button.dataset.optionPosition, 10);
      var mediaUrl = '';

      if (contextualState) {
        mediaUrl = getContextualOptionMediaUrl(contextualState, position, button.dataset.optionValueId);
      } else if (product && Array.isArray(product.variants) && position) {
        var candidateSelection = {};
        Object.keys(selected).forEach(function (key) {
          candidateSelection[key] = selected[key];
        });
        candidateSelection[position] = button.dataset.value;
        mediaUrl = getVariantImageUrl(findVariant(product, candidateSelection), 120);
      }

      var currentMediaUrl = button.dataset.variantImageUrl || '';
      if (mediaUrl === currentMediaUrl) {
        setVariantImageSwatchLoading(button, false);
        return;
      }

      button._variantImageLoadToken = (button._variantImageLoadToken || 0) + 1;
      var loadToken = button._variantImageLoadToken;
      setVariantImageSwatchLoading(button, Boolean(mediaUrl));

      if (!mediaUrl) {
        applyVariantImageSwatchStyle(button, '');
        setVariantImageSwatchLoading(button, false);
        return;
      }

      var image = new Image();
      image.onload = function () {
        if (button._variantImageLoadToken !== loadToken) return;
        applyVariantImageSwatchStyle(button, mediaUrl);
        setVariantImageSwatchLoading(button, false);
      };
      image.onerror = function () {
        if (button._variantImageLoadToken !== loadToken) return;
        applyVariantImageSwatchStyle(button, '');
        setVariantImageSwatchLoading(button, false);
      };
      image.src = mediaUrl;
    });
  }

  function syncQuantityControls(options) {
    var root = options.root || document;
    var variant = options.variant;
    var state = options.state;
    var qtyInput = root.querySelector(options.inputSelector);
    var qtyValue = root.querySelector(options.valueSelector);
    var minus = root.querySelector(options.minusSelector);
    var plus = root.querySelector(options.plusSelector);
    if (!qtyInput || !qtyValue || !variant) return 0;

    var quantityRule = getQuantityRule(variant, state);
    var soldOut = isSoldOut(variant, state);
    var max = getEffectiveMaxQty(variant, state);
    var min = getMinimumAddQty(variant, state);
    var unavailable = soldOut || (max !== null && max < min);
    var nextQty = unavailable ? 0 : normalizeQty(options.keepCurrentValue ? qtyInput.value : min, variant, state, false);

    qtyInput.value = nextQty;
    qtyValue.textContent = nextQty;
    qtyInput.min = min;
    qtyInput.step = quantityRule.increment;
    if (max !== null) qtyInput.max = max;
    else qtyInput.removeAttribute('max');

    if (minus) minus.disabled = unavailable || nextQty <= min;
    if (plus) plus.disabled = unavailable || (max !== null && nextQty >= max);
    if (typeof options.onChange === 'function') options.onChange(variant, nextQty);
    return nextQty;
  }

  function collectProperties(form) {
    var properties = {};
    if (!form) return properties;
    var formData = new FormData(form);
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (!match) return;
      if (value === '' || value === null || value === undefined) return;
      if (typeof File !== 'undefined' && value instanceof File) return;
      properties[match[1]] = value;
    });
    return properties;
  }

  function formHasFiles(form) {
    if (!form || !form.querySelectorAll) return false;
    return Array.prototype.some.call(form.querySelectorAll('input[type="file"]'), function (input) {
      return input.files && input.files.length;
    });
  }

  window.AxiomVariantForm = {
    getVariantState: getVariantState,
    getQuantityRule: getQuantityRule,
    shouldCheckInventory: shouldCheckInventory,
    getInventoryQuantity: getInventoryQuantity,
    variantRequiresSellingPlan: variantRequiresSellingPlan,
    getSellingPlanAllocations: getSellingPlanAllocations,
    getSellingPlanAllocationById: getSellingPlanAllocationById,
    getFirstSellingPlanAllocation: getFirstSellingPlanAllocation,
    isSoldOut: isSoldOut,
    getEffectiveMaxQty: getEffectiveMaxQty,
    getMinimumAddQty: getMinimumAddQty,
    syncCartQuantity: syncCartQuantity,
    normalizeQty: normalizeQty,
    selectedOptions: selectedOptions,
    getVariantOptions: getVariantOptions,
    isOtherProductOption: isOtherProductOption,
    otherProductOptionUrl: otherProductOptionUrl,
    resolveOtherProductOptionUrl: resolveOtherProductOptionUrl,
    combinedListingPosition: combinedListingPosition,
    syncCombinedListingValues: syncCombinedListingValues,
    findCombinedListingVariant: findCombinedListingVariant,
    findVariant: findVariant,
    findAvailableVariantForOptionValue: findAvailableVariantForOptionValue,
    isOptionValueAvailable: isOptionValueAvailable,
    setVariantImageSwatchesLoading: setVariantImageSwatchesLoading,
    syncVariantImageSwatches: syncVariantImageSwatches,
    syncQuantityControls: syncQuantityControls,
    collectProperties: collectProperties,
    formHasFiles: formHasFiles
  };
})();
